module.exports = __webpack_public_path__ + "img/rail-endings-background.31b3de8c.png";